module.exports = __webpack_public_path__ + "media/PAG91-06.3612613f.mp3";